/**
 * Created by huangdie on 2018/3/30.
 */

import AutoCloseDialog from '../components/AutoCloseDialog.vue'

const install = Vue => {
    Object.defineProperty(Vue.prototype, '$showMessage', {
        get() {
            let div = document.createElement('div');
            document.body.appendChild(div);
            return (message, type) => {
                const Constructor = Vue.extend(AutoCloseDialog);
                let instance = new Constructor({
                    propsData: {
                        content: message,
                        type: type
                    }
                }).$mount(div);
                instance.open();
            };
        }
    });
};

export default install;



// WEBPACK FOOTER //
// ./src/global/showMessage.js